import styled from '@emotion/styled'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TitleV2 from '../../analytics-details/work-mirror/TitleV2'
import { ReactComponent as ArrowTopIcon } from '../../../assets/icons/app/arrow-top.icon.svg'
import { AuthorInterface } from '../../../core/interface/author.interface'
import { AuthorMirrorAuthorInterface } from '../../../core/interface/report/author-mirror-author.interface'

const CardStyle = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 56px;
  width: 360px;
  background-color: black;
  border-radius: 8px;
  padding: 8px;
  z-index: 10;
`

const TitleCloseStyle = styled.span`
  overflow: hidden;
  color: #fff;
  font-variant-numeric: lining-nums proportional-nums;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Vollkorn, serif;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 100%; /* 14px */
  letter-spacing: -0.14px;
  max-width: 308px;
  padding: 2px;
`

const ButtonOpenMenuStyle = styled.button`
  transform: ${({ open }: { open: boolean }) =>
    open ? 'rotate(0deg)' : 'rotate(180deg)'};
`

const AMStyle = styled.span`
  color: #8dda86;
  text-align: center;
  /* Caption/C1 - Medium - Uppercase */
  font-family: Fira Sans, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.24px;
  text-transform: uppercase;
`

const CardAuthorInputStyle = styled.div`
  background: ${({ isSelected }: { isSelected: boolean }) =>
    isSelected ? '#e3e3e3' : 'white'};
  width: 100%;
  border-radius: 4px;
  padding: 5px;
`

const ShareAnalyticDetailsAuthorsInputs = ({
  authorsInput,
  authorDetailsSelected,
  handleAuthorSelected,
}: {
  authorsInput: AuthorInterface[]
  authorDetailsSelected: AuthorMirrorAuthorInterface | null
  handleAuthorSelected: (author: AuthorMirrorAuthorInterface | null) => void
}) => {
  const { t } = useTranslation()
  const [authorInputMenu, setAuthorInputMenu] = useState<boolean>(false)

  const handleOpenMenu = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault()
      setAuthorInputMenu(!authorInputMenu)
    },
    [authorInputMenu],
  )

  const handleAuthorToSelected = (author: AuthorInterface) => {
    handleAuthorSelected(
      authorDetailsSelected?.author_id === author.id
        ? null
        : {
            popularity: 0,
            position: 0,
            author_id: author.id,
            author,
          },
    )
  }

  return (
    <CardStyle className="flex flex-col gap-[8px]">
      <div className="flex flex-row justify-between items-center h-full">
        <div className="flex flex-row justify-start items-center h-[40px] gap-[4px]" />
        <AMStyle>{t('worksMirrors')}</AMStyle>
        <div
          className="flex flex-col items-center justify-around"
          style={{
            minHeight: 40,
            maxHeight: 40,
          }}
        >
          <ButtonOpenMenuStyle
            type="button"
            open={authorInputMenu}
            onClick={handleOpenMenu}
          >
            <ArrowTopIcon className="text-[#f4f4f4] w-5 h-5" />
          </ButtonOpenMenuStyle>
        </div>
      </div>
      {(authorInputMenu && (
        <div className="flex flex-col gap-1">
          {authorsInput.map((authorInput: AuthorInterface) => (
            <CardAuthorInputStyle
              key={`input-author-card-${authorInput.id}`}
              isSelected={authorDetailsSelected?.author_id === authorInput.id}
              className="relative flex flex-row items-center justify-start gap-2"
              onClick={(event: React.MouseEvent) => {
                event.preventDefault()
                handleAuthorToSelected(authorInput)
              }}
            >
              <div className="flex flex-col items-start">
                <TitleV2 title={authorInput?.name?.trim()} />
              </div>
            </CardAuthorInputStyle>
          ))}
        </div>
      )) || (
        <div className="flex flex-col gap-2">
          {authorsInput.map((authorInput: AuthorInterface) => (
            <div
              key={`input-author-card-${authorInput.id}`}
              className="flex flex-row items-center justify-start gap-2"
            >
              <TitleCloseStyle>{authorInput.name}</TitleCloseStyle>
            </div>
          ))}
        </div>
      )}
    </CardStyle>
  )
}

export default ShareAnalyticDetailsAuthorsInputs
